import { useEffect, useState } from "react";
import { ApiRequest } from "GlobalFunctions";

const FALLBACK_CONTENT = `
<h1>Términos y Condiciones de Uso de especialistaenheridas.cl</h1>
<h2>1. Propósito de la Plataforma</h2>
<p>especialistaenheridas.cl es una plataforma digital que conecta pacientes con enfermeras especializadas en curación de heridas.</p>
<ul>
  <li>No presta servicios médicos ni realiza diagnósticos.</li>
  <li>No garantiza la calidad de los servicios ofrecidos por las enfermeras.</li>
  <li>La responsabilidad de cada atención recae exclusivamente en las enfermeras, quienes deben cumplir con las normativas legales y sanitarias vigentes en Chile.</li>
</ul>
<h2>2. Uso de la Plataforma por Pacientes</h2>
<p>Los pacientes se comprometen a proporcionar información veraz y usar las herramientas de contacto exclusivamente para fines relacionados con la curación de heridas.</p>
<h2>3. Uso de la Plataforma por Enfermeras</h2>
<p>Las enfermeras deben demostrar capacitación en curación avanzada de heridas mediante certificados válidos y cumplir con las normativas legales y sanitarias vigentes en Chile.</p>
<h2>4. Perfiles y Membresías</h2>
<p>La plataforma ofrece perfiles básico y preferente con distintos beneficios.</p>
<h2>5. Resolución de Conflictos</h2>
<p>Cualquier conflicto derivado del uso de la plataforma será resuelto conforme a las leyes chilenas.</p>
<h2>6. Modificación de Términos</h2>
<p>especialistaenheridas.cl se reserva el derecho de modificar estos términos en cualquier momento.</p>
`;

export default function Terms(props: any) {
    const [content, setContent] = useState('');

    useEffect(() => {
        ApiRequest({
            url: '/settings/details',
            method: 'GET',
            setResponse: (response: any) => {
                const tc = response?.seo?.terms_content;
                setContent(tc && tc.trim() ? tc : FALLBACK_CONTENT);
            }
        });
    }, []);

    return (
        <div className="content ql-snow">
            <div
                className="ql-editor"
                style={{ padding: 0 }}
                dangerouslySetInnerHTML={{ __html: content || FALLBACK_CONTENT }}
            />
        </div>
    );
}
